import { useCallback } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import {
  CheckBoxLabel,
  CheckBoxWrapper,
  StyledCheckBox,
} from './CheckBoxField.style';
import { CheckBoxPropsType } from './CheckBoxField.types';
import defaultCheckmark from 'assets/icons/form/checkmark.svg';
import { createCheckBoxTheme } from './CheckBoxField.theme';
import { ThemeProvider } from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';

export const CheckBoxField = ({
  name,
  id = name,
  onChangeCallback,
  labelPosition = 'RIGHT',
  disabled,
  icon = defaultCheckmark,
  label,
  i18n = true,
  i18nExtraProps,
  children,
  customCheckboxTheme,
  ...marginProps
}: CheckBoxPropsType) => {
  const theme = createCheckBoxTheme(customCheckboxTheme);
  const { control } = useFormContext();
  const {
    field: { onChange, ...field },
  } = useController({
    name,
    control,
  });
  const { t } = useTranslation();

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (typeof onChangeCallback === 'function') {
        onChangeCallback(e);
      } else onChange(e);
    },
    [onChange],
  );

  return (
    <ThemeProvider theme={theme}>
      <CheckBoxWrapper labelPosition={labelPosition} {...marginProps}>
        <StyledCheckBox
          id={id}
          type="checkbox"
          onChange={onChangeHandler}
          disabled={disabled}
          icon={icon}
          defaultChecked={field.value}
          {...field}
        />
        {label ? (
          <CheckBoxLabel htmlFor={id}>
            {i18n ? <Trans t={t} i18nKey={label} {...i18nExtraProps} /> : label}
          </CheckBoxLabel>
        ) : (
          children
        )}
      </CheckBoxWrapper>
    </ThemeProvider>
  );
};
